// src/models/fiscal/Veiculo.js
export class Veiculo {
  constructor(data = {}) {
    this.id = data.id ?? 0;
    this.filialId = data.filialId ?? 1;
    this.placa = data.placa ?? '';
    this.renavam = data.renavam ?? '';
    this.uf = data.uf ?? '';
    this.tara = data.tara ?? 0;
    this.capacidadeKG = data.capacidadeKG ?? null;
    this.capacidadeM3 = data.capacidadeM3 ?? null;
    this.tipoRodado = data.tipoRodado ?? 1;
    this.tipoCarroceria = data.tipoCarroceria ?? 0;
    this.rntrc = data.rntrc ?? '';
    this.tipo = data.tipo ?? 1;
    this.ativo = data.ativo ?? true;
  }
}
